/**
 * Luật thuần của màn kho bản OCR: kiểm tệp trước khi gửi, chọn model đọc chữ mặc định, tiến độ đọc.
 * Trả **mã** để view tự dịch; không dựng chuỗi hiển thị.
 */
import type { AiModelOption } from '../../ai-model/types';
import type { OcrVersion } from '../types';

/** Giới hạn của `POST /ocr-files/upload` (`MAX_DOCUMENT_FILES`, `OCR_UPLOAD_MAX_FILE_MB` mặc định). */
export const TOI_DA_SO_TEP = 20;
export const TOI_DA_MOI_TEP = 25 * 1024 * 1024;

/** Kho chỉ đọc trước được PDF và ảnh (`isPageReadableKind`). */
export function docTruocDuoc(mime: string): boolean {
  return mime === 'application/pdf' || mime.startsWith('image/');
}

export type LoiTep = 'sai-dinh-dang' | 'qua-lon';

export interface KetQuaKiemTep {
  /** Lỗi theo từng tệp, khoá theo chỉ số trong mảng đầu vào. */
  theoTep: Array<{ chiSo: number; ten: string; loi: LoiTep }>;
  quaNhieuTep: boolean;
  hopLe: boolean;
}

export function kiemTep(tep: ReadonlyArray<{ name: string; type: string; size: number }>): KetQuaKiemTep {
  const theoTep: KetQuaKiemTep['theoTep'] = [];
  tep.forEach((f, chiSo) => {
    if (!docTruocDuoc(f.type)) theoTep.push({ chiSo, ten: f.name, loi: 'sai-dinh-dang' });
    else if (f.size > TOI_DA_MOI_TEP) theoTep.push({ chiSo, ten: f.name, loi: 'qua-lon' });
  });
  const quaNhieuTep = tep.length > TOI_DA_SO_TEP;
  return { theoTep, quaNhieuTep, hopLe: tep.length > 0 && theoTep.length === 0 && !quaNhieuTep };
}

/** Model đọc chữ: chỉ model đọc riêng từng trang được. */
export function modelDocChu(ds: readonly AiModelOption[]): AiModelOption[] {
  return ds.filter((m) => m.can_read_pages);
}

/** Mặc định: model mặc định của tổ chức nếu nó đọc chữ được, không thì model đọc chữ đầu tiên. */
export function modelDocChuMacDinh(ds: readonly AiModelOption[]): string | undefined {
  const doc = modelDocChu(ds);
  return (doc.find((m) => m.is_default) ?? doc[0])?.key;
}

/** Phần trăm đọc của một bản đang chạy; `null` khi chưa biết số trang. */
export function phanTramDoc(v: Pick<OcrVersion, 'pages_done' | 'page_count'>): number | null {
  if (!v.page_count || v.page_count <= 0) return null;
  return Math.min(100, Math.round(((v.pages_done ?? 0) / v.page_count) * 100));
}

export function dangDoc(v: Pick<OcrVersion, 'status'>): boolean {
  return v.status === 'QUEUED' || v.status === 'READING';
}
